const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReliability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2755 43.3995H4L8.51876 10.7181L30.6778 10.666L24.1844 28.9798H40.5266L15.2755 68.072V49.0418",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9588 14.4502H43.0127L51.8788 22.4376L43.0127 30.4281",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5929 30.4277H55.3351L63.8613 38.4152L55.3351 46.4056",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1901 46.4062H67.6577L76.5238 54.3967L67.6577 62.3842H25.4244",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReliability);
export default __webpack_public_path__ + "static/media/icon-reliability.6e75091f6f5d07c5731858f726c43d27.svg";
export { ForwardRef as ReactComponent };